export type PostEmployeeCostCenterApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostEmployeeCostCenterApiArg = {
  body: {
    description: string;
    company: string;
    branch: string;
  } | null;
};
export type GetEmployeeCostCenterApiResponse =
  | /** status 200 Standard response */ ({
      description?: string | null;
      company?: string | null;
      branch?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetEmployeeCostCenterApiArg = {
  /** Name */
  id: string;
};
export type DeleteEmployeeCostCenterApiResponse = unknown;
export type DeleteEmployeeCostCenterApiArg = {
  /** Name */
  id: string;
};
export type PatchEmployeeCostCenterApiResponse = unknown;
export type PatchEmployeeCostCenterApiArg = {
  /** Name */
  id: string;
  body: {
    description: string;
    company: string;
    branch: string;
  } | null;
};
export type GetEmployeeCostCentersListApiResponse =
  | /** status 200 Standard response */ ({
      costCenters?: ({
        id?: string | null;
        description?: string | null;
        branch?: string | null;
        company?: string | null;
        isActive?: boolean | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetEmployeeCostCentersListApiArg = {
  /** GUID */
  company: string;
  /** GUID */
  branch: string;
};
export type PostEmployeeCostCenterSetAsActiveApiResponse =
  /** status 204 Standard response */ undefined;
export type PostEmployeeCostCenterSetAsActiveApiArg = {
  /** Name */
  costCenterId: string;
};
export type PostEmployeeCostCenterSetAsInactiveApiResponse =
  /** status 204 Standard response */ undefined;
export type PostEmployeeCostCenterSetAsInactiveApiArg = {
  /** Name */
  costCenterId: string;
};
